import Category from "@/components/category";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type SmallProps = {
  article: Content.Article;
};

const Small = (props: SmallProps) => {
  const category = props.article.fields.categories?.[0];
  const image =
    props.article.fields.teaserImage || props.article.fields.images?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;

  return (
    <Link
      href={`/${props.article.fields.slug}`}
      className="group relative overflow-hidden"
    >
      <div className="grid grid-cols-12 gap-2">
        <div className="col-span-8">
          {category && <Category category={category} />}
          {title && <TeaserHeading text={title} className="text-xl" />}
        </div>
        <div className="col-span-4">
          {image?.fields?.file?.url && (
            <div className="relative w-full aspect-h-9 aspect-w-16">
              <div className="bg-sand-800">
                <Image
                  fill
                  src={createImageUrl(image.fields.file.url, { crop: "16:9" })}
                  alt={image.fields.alt || ""}
                  className="object-cover"
                  sizes={createImageSizes({
                    mobile: "12vw",
                    tablet: "12vw",
                    desktop: "12vw",
                  })}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default Small;
